import "./ButtonReset.css";
import { useChatboxDispatchContext } from "../../../context/ChatboxContext";
import Reset from 'jsx:../../../assets/restart-blue.svg';
import BotService from '../../../actions/ConversationAction';
const ButtonReset = () => {
  const {refreshDeeplyConversation}=BotService();
  return (
    <button className="restart_chatbox" onClick={refreshDeeplyConversation}>
       <Reset/>
    </button>
  );
};

export default ButtonReset;